import { CSSProperties, FC } from 'react';

import SpinnerV2 from './SpinnerV2';

interface ILoading {
    relative?: boolean;
    style?: CSSProperties;
}

const Loading: FC<ILoading> = ({ style, relative, ...props }) => (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '10px auto', ...style }} {...props}>
        <SpinnerV2 relative={relative} />
    </div>
);

export default Loading;
